const ErrorMessage = () => <div>:(</div>;

export default ErrorMessage;
